export const hmiObjectTreeConstant = {

    HMI__OBJECT_TREE_UPDATE_SUCCESS: 'HMI__OBJECT_TREE_UPDATE_SUCCESS',
    HMI__OBJECT_TREE_UPDATE_FAILURE: 'HMI__OBJECT_TREE_UPDATE_FAILURE',
    HMI__OBJECT_TREE_DELETE_SUCCESS: 'HMI__OBJECT_TREE_DELETE_SUCCESS',
    HMI__OBJECT_TREE_DELETE_FAILURE: 'HMI__OBJECT_TREE_DELETE_FAILURE',
};  